import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.rolle-umbenennen';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungRolleUmbenennenEffects {

    RolleUmbenennen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_ROLLE_UMBENENNEN),
        mergeMap((x: ac.PostRolleUmbenennenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postRolleUmbenennen(x.rolleUmbenennenRequest).pipe(
                map((result: any) => {
                    return new ac.PostRolleUmbenennenErfolgreichAction(result, x.rolleUmbenennenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostRolleUmbenennenFehlerAction(error, x.rolleUmbenennenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.RollenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.RollenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.RollenCommandService);
        }
        return this.service;
    }
}
